<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <template v-if="!externalControl">
            <checkbox label-size="xs" v-model="count" :label="$lang.count" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="buttons" :label="$lang.buttons" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="endless" :disabled="autoplay" :label="$lang.endless" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="autoplay" :label="$lang.autoplay" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown :title="$lang.dots" :class="['mr-2']" v-model="dots" :items="dotsOptions" width="100px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" /><!---->
          </template>
          <checkbox label-size="xs" v-model="externalControl" :label="$lang.externalControl" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24" v-if="externalControl">
        <card>
          <card-text>
            <md-section md="carousel-external-control.md" />
          </card-text>
          <divider />
          <card-actions align="center">
            <pager
              align="center"
              size="xs"
              v-model="pager"
              :count="5"
              color="white"
              selected-bg-color="black"
              :color-lightness="null"
              :bg-color="$root.colors.primary"
              :bg-color-lightness="$root.colors.bgColorLightness"
              :selected-bg-color-lightness="null"
              @input="onPagerInput" />
          </card-actions>
        </card>
      </flex-col>
      <flex-col :span="24">
        <carousel ref="carousel" @scroll="onScroll" :count="count" :count-divider="false" :buttons="buttons" :autoplay="autoplay ? 2000 : null" :dots="dots[0]" :endless="endless" :count-color="$root.$colors.primary" :count-color-lightness="$root.$colors.bgColorLightness" :ui-color="$root.$colors.primary" :ui-color-lightness="$root.$colors.bgColorLightness">
          <carousel-slide v-for="slide in 5" :key="slide">
            <img v-aspect-ratio="5/3" :class="['block']" :src="`${$root.config.staticAssetsDir}/images/guitars/aurellia-egotalker-iii/image-0${slide}.jpg`" />
          </carousel-slide>
        </carousel>
      </flex-col>
      <flex-col :span="24">
        <md-section md="carousel-methods.md" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageCarousel',
  mixins: [
    methods
  ],
  data () {
    return {
      dots: ['bottom'],
      buttons: true,
      endless: false,
      autoplay: false,
      count: true,
      externalControl: false,
      pager: 0,
      dotsOptions: ['top', 'bottom', 'none'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      })
    }
  },
  watch: {
    autoplay () {
      if (this.autoplay) {
        this.endless = true
      }
    },
    dots () {
      if (this.dots[0] === 'none') {
        this.buttons = true
      }
    }
  },
  methods: {
    onScroll ($event) {
      this.pager = $event
      this.log('scroll', 'carousel', $event)
    },
    onPagerInput ($event) {
      this.$refs['carousel'].scroll($event)
      this.log('input', 'pager', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/carousel.vue